// FIRMA, INICIALES Y NOMBRE DONDE LA AGENTE QUIERA, LAS VECES QUE HAGA FALTA
//
// Lissette 2026-10-23: *"en las plantillas, la opción de colocar más firmas: si
// un documento necesita que firme en varios lados, y las iniciales, y el nombre
// y apellido"*.
//
// Mismo sistema que las preguntas clavadas (`marcadorDePregunta.js`): la
// plantilla lleva un marcador donde va cada cosa, y se puede repetir.
//
//   {{f:firma}}      la firma del cliente (la misma imagen en cada sitio)
//   {{f:iniciales}}  sus iniciales
//   {{f:nombre}}     su nombre y apellido, escrito
//
// El cliente firma UNA vez, escribe sus iniciales y su nombre UNA vez, y salen
// en todos los sitios marcados. Los DOS PUNTOS son a propósito, como en
// `{{q:id}}`: el lector de campos del editor (`templatePlaceholders`) no los ve,
// así que no se le piden a la AGENTE al enviar.
//
// Gemelo de deskte-api/src/utils/camposDeFirma.ts. Una prueba exige que la
// expresión sea la misma cadena en los dos.

export const CAMPOS_DE_FIRMA = ['firma', 'iniciales', 'nombre'];

/** Reconoce {{f:firma}}, {{f:iniciales}} y {{f:nombre}}. Misma cadena que en el servidor. */
export const MARCADOR_DE_CAMPO_DE_FIRMA = /\{\{\s*f:(firma|iniciales|nombre)\s*\}\}/g;

/** El marcador de un campo, para escribirlo en el cuerpo. */
export function marcadorDeCampo(campo) {
  return `{{f:${campo}}}`;
}

/** Los campos que pide este documento (sin repetir). */
export function camposUsadosEn(texto) {
  const out = [];
  const re = new RegExp(MARCADOR_DE_CAMPO_DE_FIRMA.source, 'g');
  const fuente = String(texto || '');
  let m = re.exec(fuente);
  while (m) {
    if (!out.includes(m[1])) out.push(m[1]);
    m = re.exec(fuente);
  }
  return out;
}

/**
 * Parte los trozos de TEXTO por los campos de firma, para pintarlos en su sitio.
 * Recibe lo que devuelve `partirPorPreguntas` (texto / pregunta) y devuelve lo
 * mismo con trozos `{ tipo: 'campo', campo: 'firma' | 'iniciales' | 'nombre' }`
 * en medio. Las preguntas pasan tal cual. Un documento sin estos marcadores
 * sale idéntico.
 */
export function partirPorCamposDeFirma(trozos) {
  const out = [];
  for (const t of (Array.isArray(trozos) ? trozos : [])) {
    if (!t || t.tipo !== 'texto') { out.push(t); continue; }
    const fuente = String(t.valor || '');
    const re = new RegExp(MARCADOR_DE_CAMPO_DE_FIRMA.source, 'g');
    let ultimo = 0;
    let m = re.exec(fuente);
    while (m) {
      if (m.index > ultimo) out.push({ tipo: 'texto', valor: fuente.slice(ultimo, m.index) });
      out.push({ tipo: 'campo', campo: m[1] });
      ultimo = m.index + m[0].length;
      m = re.exec(fuente);
    }
    if (ultimo < fuente.length || ultimo === 0) out.push({ tipo: 'texto', valor: fuente.slice(ultimo) });
  }
  return out;
}

/** "Ana María Pérez" → "AMP". Como mucho 4 letras. */
export function inicialesDe(nombre) {
  return String(nombre || '').trim().split(/\s+/).filter(Boolean)
    .map((p) => p[0]).join('').toUpperCase().slice(0, 4);
}

/** Lo más largo que se acepta como nombre y apellido (igual que el servidor). */
export const MAX_NOMBRE_DEL_FIRMANTE = 120;
